<template>
    <div class="container-fluid">
        <div class="card mb-25 border-0 rounded-0 bg-white add-besc-card shadow-sm">
            
            <!-- Section corrections demandées -->
            <div v-if="corrections.length > 0" class="alert alert-warning mb-4">
              <h6 class="text-primary fw-semibold mb-3">
                <i class="fas fa-exclamation-triangle me-2"></i>
                Corrections demandées ({{ corrections.length }})
              </h6>
              
              <div class="corrections-list">
                <div v-for="correction in corrections" :key="correction.id" 
                     class="d-flex align-items-center justify-content-between p-2 mb-2 bg-light rounded">
                  <div class="flex-grow-1">
                    <small class="fw-semibold">{{ correction.fields_concerned }}</small>
                    <p class="mb-0 small text-muted">{{ correction.message_to_requester }}</p>
                  </div>
                  <button @click="markCorrectionAsFixed(correction.id)" 
                          class="btn btn-success btn-sm">
                    <i class="fas fa-check me-1"></i>
                    Corrigé
                  </button>
                </div>
              </div>
            </div>

            <div class="card-header d-flex justify-content-between align-items-center py-4 px-4"
                style="background-color: #0a59a4;">
                <div>
                    <h3 class="text-white fw-bold mb-1">Étape 3/3 – Documents & Validation finale</h3>
                    <small class="text-white opacity-75">Téléversez les documents nécessaires et validez le BESC</small>
                </div>
            </div>

            <div class="card-body p-15 p-sm-20 p-md-30 letter-spacing">
                <div class="border border-primary rounded-3 shadow-sm overflow-hidden">
                    <div class="row d-flex align-items-center justify-content-between fw-bold py-3 px-4 m-0"
                        style="background-color: #0a59a4;">
                        <div class="col-md-7">
                            <h5 class="text-white mb-0">Pièce(s) jointe(s)</h5>
                        </div>
                        <div class="col-md-5 text-end">
                            <button type="button" class="btn btn-light btn-sm shadow-sm" @click="addPiece"
                                :disabled="!canAddPiece">
                                Ajouter une pièce
                            </button>
                        </div>
                    </div>

                    <div class="p-4">
                        <div class="row gx-3 mb-3 fw-bold text-muted small">
                            <div class="col-md-5">TYPE DE DOCUMENT</div>
                            <div class="col-md-5">FICHIER</div>
                            <!-- <div class="col-md-2 text-center">ACTION</div> -->
                        </div>

                        <hr class="mt-0 mb-4">
                        <div v-for="(piece, index) in pieces" :key="piece.id ? 'doc-' + piece.id : piece._key"
                            class="row gx-3 align-items-center mb-3 pb-3 border-bottom">

                            <!-- TYPE -->
                            <div class="col-md-5">
                                <Multiselect v-model="piece.type" :options="typeDocuments" label="label"
                                    track-by="value" placeholder="Sélectionner le type" :searchable="true"
                                    :close-on-select="true" :show-labels="false" :object="true" />
                            </div>

                            <!-- FICHIER -->
                            <div class="col-md-5">
                                <input type="file" class="form-control shadow-sm" @change="e => handleFile(e, index)" />

                                <small v-if="piece.filename" class="text-success d-block mt-2">
                                    {{ piece.filename }}
                                </small>
                            </div>
                            <!-- ACTION -->
                            <!-- <div class="col-md-2 text-center">
                                <button v-if="pieces.length > 1" type="button" class="btn btn-danger btn-sm"
                                    @click="removePiece(index)">
                                    Supprimer
                                </button>
                                <span v-else class="text-muted small">—</span>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-5 pt-4 border-top">
                    <router-link :to="{ name: 'EditAddBescStep2', params: { id: bescId } }" class="btn btn-danger px-4">
                        Retour à l'étape 2
                    </router-link>

                    <button type="button" @click="goToRecap" class="btn px-5 py-2 text-white"
                        style="background-color: #0a59a4; border: none;" :disabled="!hasAllDocuments">
                        Mettre à jour & Passez à l'étape 4
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, reactive } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import Multiselect from '@vueform/multiselect'
import ApiService from '@/services/ApiService'
import { success, error } from '@/utils/utils'

interface TypeDoc {
    value: string
    label: string
    obligatoire: boolean
}

interface PieceJointe {
    _key: string
    id?: string
    type: { value: string; label: string; obligatoire: boolean } | null
    fichier: File | null
    filename: string
    url?: string
}


export default defineComponent({
    name: 'EditAddBescStep3',
    components: { Multiselect },

    setup() {
        const route = useRoute()
        const router = useRouter()
        const bescId = route.params.id as string

        const typeDocuments = ref<TypeDoc[]>([])
        const pieces = ref<PieceJointe[]>([])
        
        // Variables pour les corrections
        const corrections = ref<any[]>([])

        const fetchRequestCorrection = async () => {
                try {
                    const { data } = await ApiService.get(`/corrections/besc/${bescId}`)
                    console.log("dattaaaa",data);
                    
                    corrections.value = data.data.filter((cor: any) => cor.status === 'OPEN')
                    
                } catch(err: any) {
                    error(err.response?.data?.message || 'Erreur de récupération')
                }
            }

       const markCorrectionAsFixed = async (correctionId: string) => {
                try {
                    await ApiService.patch(`/correction/${correctionId}/status`, { 
                        status: 'RESOLVED' 
                    })
                    
                    corrections.value = corrections.value.filter(c => c.id !== correctionId)
                    success('Correction marquée comme résolue !')
                    
                } catch (err: any) {
                    error('Erreur lors de la mise à jour')
                }
            }


        const hasAllDocuments = computed(() =>
            pieces.value.length > 0 &&
            pieces.value.every(p => p.type && (p.fichier || p.filename))
        )

        const canAddPiece = computed(() => {
            if (!pieces.value.length) return true
            const last = pieces.value[pieces.value.length - 1]
            return !!(last.type && (last.fichier || last.filename))
        })


        const loadTypes = async () => {
            const res = await ApiService.get('/typeDocumentBescs')
            typeDocuments.value = res.data.data.data.map((t: any) => ({
                value: t.id,
                label: t.libelle,
                obligatoire: t.obligatoire
            }))
            success("Type de documents et fichiers  chargés avec succès");
        }

        const loadExistingDocuments = async () => {
            // Charger les types si pas encore fait
            if (!typeDocuments.value.length) await loadTypes();
            const res = await ApiService.get(`/besc/${bescId}/document`);
            const docs = res.data.data || [];
            // pieces.value = docs.map(doc => reactive({
            //     _key: `doc-${doc.id}`,
            //     id: doc.id,
            //     type: typeDocuments.value.find(t => t.value === doc.typeDocument.id) || null,
            //     fichier: null,
            //     filename: doc.nomFichierOriginal || doc.nomFichier,
            //     url: `/Uploads/besc/${bescId}/${doc.nomFichier}`
            // }))
            pieces.value = docs.map(doc => reactive({
                _key: `doc-${doc.id}`,
                id: doc.id,
                type: typeDocuments.value.find(t => t.value === doc.typeDocument?.id) || {
                    value: doc.typeDocument?.id,
                    label: doc.typeDocument?.label || 'Type inconnu',
                    obligatoire: doc.typeDocument?.obligatoire || false
                },
                fichier: null,
                filename: doc.nomFichierOriginal || doc.nomFichier,
                url: `/Uploads/besc/${bescId}/${doc.nomFichier}`
            }))
            if (pieces.value.length === 0) {
                pieces.value.push({
                    _key: `tmp-${Date.now()}`,
                    type: null,
                    fichier: null,
                    filename: '',
                    url: ''
                });
            }
        };


        const handleFile = (e: Event, index: number) => {
            const file = (e.target as HTMLInputElement).files?.[0]
            if (!file) return

            pieces.value[index].fichier = file
            pieces.value[index].filename = file.name
        }

        const addPiece = () => {
            pieces.value.push(
                reactive({
                    _key: `temp-${Date.now()}-${Math.random()}`,
                    id: undefined,
                    type: null,
                    fichier: null,
                    filename: ''
                })
            )
        }


        const removePiece = (index: number) => {
            pieces.value.splice(index, 1)
        }

        const goToRecap = async () => {
            try {
                await updateDocuments()
                success('Documents mis à jour avec succès')
                router.push({ name: 'Recapitulatif', params: { id: bescId } })
            } catch {
                error('Erreur lors de la sauvegarde des documents')
            }
        }
        const updateDocuments = async () => {
            const formData = new FormData();
            pieces.value.forEach((p, index) => {
                if (p.fichier && !p.id) {
                    // nouvelle pièce
                    formData.append('files', p.fichier);
                    formData.append('type_ids', p.type!.value);
                } else if (p.id && p.fichier) {
                    // ancien document remplacé
                    formData.append('files', p.fichier);
                    formData.append('document_ids', p.id);
                    formData.append('type_ids', p.type!.value);
                } else if (p.id && !p.fichier) {
                    // ancien document type modifié
                    formData.append('existing_ids', p.id);
                    formData.append('existing_type_ids', p.type!.value);
                }
            });


            // Debug : vérifier ce qu'on envoie
            console.log('FormData envoyé :');
            for (const [key, value] of formData.entries()) {
                console.log(key, value);
            }

            try {
                await ApiService.vueInstance.axios.put(
                    `/besc/${bescId}/document`,
                    formData,
                    { headers: { 'Content-Type': 'multipart/form-data' } }
                );
                await loadExistingDocuments(); // recharge après succès
            } catch (err: any) {
                console.error('Erreur API:', err.response?.data || err.message);
                throw err;
            }
        };
        onMounted(async () => {
            await loadTypes()
            await loadExistingDocuments()
            await fetchRequestCorrection()
        })

        return {
            bescId,
            typeDocuments,
            pieces,
            hasAllDocuments,
            canAddPiece,
            addPiece,
            removePiece,
            handleFile,
            goToRecap,
            corrections,
            markCorrectionAsFixed
        }
    }
})
</script>
